








































import Vue from "vue";
export default Vue.extend({
  name: "DocumentLibraryDetails",
  data() {
    return {
      documentList: {
        "Westlake Stakeholder Meeting": [
          {
            title: "Westlake Meeting Presentation",
            uploadDate: "November 2024",
            file: "2024_0930_Westlake Stakeholder_Presentation_final.pdf"
          },
          {
            title: "Westlaker Meeting Script",
            uploadDate: "November 2024",
            file: "Westlake Stakeholder Meeting Presentation Script.pdf"
          }
        ],
        "I-10 Calcasieu River Bridge Final EIS and Record of Decision":[
        {
            title: "I-10 Calcasieu River Bridge Final EIS",
            uploadDate: "September 2023",
            file: "H.003931+FEIS+09112023.pdf"
          },{
            title: "I-10 Calcasieu River Bridge Final EIS Appendices",
            uploadDate: "September 2023",
            file: "H003931_FEIS_Appendices.pdf"
          },{
            title: "I-10 Calcasieu River Bridge Record of Decision",
            uploadDate: "January 2024",
            file: "H.003931 ROD_2024_0130 Complete.pdf"
          }],
        "I-10 Calcasieu River Bridge Draft EIS": [
          {
            title: "I-10 Calcasieu River Bridge Draft EIS",
            uploadDate: "October 2022",
            file: "I-10 Calcasieu River Bridge Draft EIS.pdf"
          },
          {
            title: "Appendix A - Purpose and Need Technical Memorandum",
            uploadDate: "November 2017",
            file: "Appendices/A Purpose and Need Tech Memo.pdf"
          },
          {
            title: "Appendix B - Traffic Engineering Report",
            uploadDate: "May 2022",
            file: "Appendices/B Traffic_Engineering_Report.pdf"
          },
          {
            title: "Appendix C - Public and Agency Meetings",
            uploadDate: "2013 - 2021",
            file: "Appendices/Appendix C Public and Agency Meetings.pdf"
          },
          {
            title: "Appendix D - Environmental Justice Technical Memorandum",
            uploadDate: "October 2022",
            file:
              "Appendices/Appendix D Environmental Justice Technical Memorandum.pdf"
          },
          {
            title: "Appendix E - Section 106 Documentation ",
            uploadDate: "October 2022",
            file: "Appendices/Appendix E Section 106 Documentation.pdf"
          },
          {
            title: "Appendix F - Preliminary Financial Feasibility ",
            uploadDate: "April 2021",
            file: "Appendices/F Financial Feasibility.pdf"
          },
          {
            title: "Appendix G - Agency Correspondence",
            uploadDate: "2013-2021",
            file: "Appendices/Appendix G Agency Correspondence.pdf"
          },
          {
            title: "Appendix H - Design Engineering Documents",
            uploadDate: "October 2022",
            file: "Appendices/H+Engineering+Documents_10-10-23.pdf"
          },
          {
            title:
              "Appendix I - Right of Way and Relocation Assistance Brochure",
            uploadDate: "May 2019",
            file: "Appendices/I Right of Way Brochure.pdf"
          },
          {
            title: "Appendix J - Air Quality Analysis ",
            uploadDate: "October 2021",
            file: "Appendices/J Air Quality Report_10292021.pdf"
          },
          {
            title: "Appendix K - Traffic Noise Technical Analysis",
            uploadDate: "July 2022",
            file: "Appendices/Appendix K Traffic Noise Technical Report.pdf"
          },
          {
            title: "Appendix L - Wetlands and Habitat ",
            uploadDate: "May 2021",
            file: "Appendices/Appendix L Wetlands and Habitats.pdf"
          },
          {
            title: "Appendix M - Phase I Environmental Site Assessment",
            uploadDate: "August 2021",
            file: "Appendices/M Phase I ESA.pdf"
          },
          {
            title: "Appendix N - Section 4(f)",
            uploadDate: "October 2022",
            file: "Appendices/N Section 4f Statements.pdf"
          },
          {
            title: "Appendix O - EDC & VC Plume Drawings ",
            uploadDate: "2020 - 2021",
            file: "Appendices/O EDC VC Plumes.pdf"
          },
          {
            title: "Appendix P - Navigation Data Reports ",
            uploadDate: "2007-2022",
            file: "Appendices/P Navigation Data and Reports.pdf"
          },
          {
            title:
              "Appendix Q - Project Coordination and Public Involvement Plans",
            uploadDate: "2018",
            file: "Appendices/Q PCP and PIP Updates.pdf"
          }
        ],
        "Project Documents": [
          {
            title:
              "I-10 Calcasieu River Bridge and Approaches Comprehensive Preliminary Alternatives Report",
            uploadDate: "May 2002",
            file: "08_Comprehensive_Prelim_Alt_Report_2002.pdf"
          },
          {
            title: "Bridge Height Special Study",
            uploadDate: "October 2007",
            file: "BridgeHeightStudy2007.pdf"
          },
          {
            title:
              "Navigational Study for the I-10 Calcasieu River Bridge and Approaches",
            uploadDate: "September 2014",
            file: "2014 Navigation Study.pdf"
          },
          {
            title: "Objectives Screening Matrix",
            uploadDate: "August 2017",
            file: "Objectives Screening Matrix.pdf"
          },
          {
            title: "Preliminary Alternatives Screening Methodologies",
            uploadDate: "August 2017",
            file: "Preliminary Alternatives Screening Methodologies.pdf"
          },
          {
            title:
              "Alternative Screening Methodology Agency Comments & Responses",
            uploadDate: "September 2017",
            file: "Alternatives Screening Methodology.pdf"
          },
          {
            title: "Purpose and Need Technical Memorandum",
            uploadDate: "November 2017",
            file: "Purpose and Needs.pdf"
          },
          {
            title: "Project Coordination Plan",
            uploadDate: "December 2018",
            file: "Project Coordination Plan.pdf"
          },
          {
            title:
              "LADOTD Acquisition of Right-of-Way and Relocation Assistance Brochure",
            uploadDate: "May 2019",
            file: "2019+Acquistion+Brochure+revised_v2.pdf"
          }
        ],
        "Public/Agency Meeting Material": [
          {
            title:
              "Public Involvement Summary – NOI, SOV, and Public Scoping Meeting ",
            uploadDate: "February 2014",
            file:
              "H.003931_I-10_Calcasieu_EIS_Final_Public_Scoping_Meeting_Summary_Report-web.pdf"
          },
          {
            title: "Agency & Public Meeting 1 Comments & Responses",
            uploadDate: "August 2017",
            file: "Public and Agency Meeting Comments and Responses.pdf"
          },
          {
            title:
              "Public Involvement Summary Report: Elected Official's Meeting, Alternative Screening Methodology,  Agency Meeting 2, and Public Meeting 2",
            uploadDate: "September 2017",
            file: "Summary Report.pdf"
          },
          {
            title: "Public Involvement Plan",
            uploadDate: "December 2018",
            file: "Public Involvement Plan.pdf"
          },
          {
            title:
              "Public Involvement Summary Report: Elected Official / Agency Briefing and Public Meeting #3",
            uploadDate: "April 2019",
            file: "Public Involvement Summary Report.pdf"
          },

          {
            title:
              "Public Involvement Summary Report Elected Officials / Agency Briefing Public Meeting #4 and Other Outreach",
            uploadDate: "March 2021",
            file: "H003931_Calcasieu_PM4_Summary Report.pdf"
          },
          {
            title: "Public Meeting #4 Comments and Responses",
            uploadDate: "May 2021",
            file: "Comment_Responses_Attachment_I.pdf"
          },
          {
            title:
              "Context Sensitive Solutions and Design (CSS/D) Meeting #1 Summary Report",
            uploadDate: "February 2021",
            file: "CSSD_Workshop1_Summary_Rev+01.pdf"
          },
          {
            title:
              "Context Sensitive Solutions and Design (CSS/D) Meeting #2 Summary Report",
            uploadDate: "June 2021",
            file: "CSS_Mtg2_Calcasieu.pdf"
          }
        ]
      }
    };
  },
  methods: {
    link(fileName: string) {
      const formattedFileName = fileName.replace(/ /g, "+");
      return `https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/${formattedFileName}`;
    }
  }
});
